// extracted by mini-css-extract-plugin
export var createdDate = "_jj-1";
export var divider = "_jj-2";
export var headerDivider = "_jj-3";
export var messagesCard = "_jj-0";
export var messagesContainer = "_jj-7";
export var messagesContainerWrapper = "_jj-4";
export var pointerCapturingButtonBoxes = "_jj-a";
export var showLeftPanelButton = "_jj-9";
export var showMoreButton = "_jj-c";
export var showMoreButtonContainer = "_jj-b";
export var summaryTitle = "_jj-6";
export var systemMessageCardWrapper = "_jj-d";
export var topButtons = "_jj-8";
export var withPadding = "_jj-5";